import React, { useEffect, useState } from 'react';
import API from '../utils/api';

const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

export default function AdminHome() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get('/admin/dashboard').then(r => { setStats(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  if (loading) return <div className="loader"><div className="spinner" /></div>;
  if (!stats) return <p>Failed to load dashboard.</p>;

  const purposeLabel = p => ({ general: 'General', cow_adoption: 'Adoption', fodder: 'Fodder', medical: 'Medical', infrastructure: 'Infrastructure', festival: 'Festival' }[p] || p);
  const categoryLabel = c => ({ dry_grass: 'Dry Grass', wet_grass: 'Wet Grass', medical: 'Medical', salary: 'Salary', infrastructure: 'Infrastructure', utilities: 'Utilities', other: 'Other' }[c] || c);

  return (
    <div>
      <h2 className="admin-page-title">📊 Dashboard Overview</h2>

      {/* Stats Cards */}
      <div className="stats-cards">
        {[
          { label: 'Total Donations', value: `₹${(stats.totalDonations || 0).toLocaleString('en-IN')}`, sub: `₹${(stats.monthlyDonations || 0).toLocaleString('en-IN')} this month`, color: 'saffron' },
          { label: 'Total Expenses', value: `₹${(stats.totalExpenses || 0).toLocaleString('en-IN')}`, sub: `₹${(stats.monthlyExpenses || 0).toLocaleString('en-IN')} this month`, color: 'brown' },
          { label: 'Net Balance', value: `₹${(stats.netBalance || 0).toLocaleString('en-IN')}`, sub: 'Donations + Milk - Expenses', color: 'green' },
          { label: 'Milk Revenue', value: `₹${(stats.milkRevenue || 0).toLocaleString('en-IN')}`, sub: 'This month', color: 'gold' },
          { label: 'Total Cows', value: stats.totalCows || 0, sub: 'Active in Goshala', color: 'saffron' },
          { label: 'Registered Users', value: stats.totalUsers || 0, sub: 'Donors & supporters', color: 'green' },
        ].map((s, i) => (
          <div key={i} className={`stat-card ${s.color}`}>
            <div className="stat-card-label">{s.label}</div>
            <div className="stat-card-value">{s.value}</div>
            <div className="stat-card-sub">{s.sub}</div>
          </div>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 }}>
        {/* Recent Donations */}
        <div style={{ background: '#fff', borderRadius: 12, padding: 24, boxShadow: '0 2px 16px rgba(0,0,0,0.08)' }}>
          <h3 style={{ fontWeight: 700, marginBottom: 16 }}>Recent Donations</h3>
          {stats.recentDonations?.length === 0 ? <p style={{ color: '#888' }}>No donations yet</p> : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9rem' }}>
              <thead><tr style={{ color: '#888', borderBottom: '1px solid #f0f0f0' }}>
                <th style={{ padding: '8px 0', textAlign: 'left' }}>Name</th>
                <th style={{ padding: '8px 0', textAlign: 'right' }}>Amount</th>
              </tr></thead>
              <tbody>
                {stats.recentDonations?.map((d, i) => (
                  <tr key={i} style={{ borderBottom: '1px solid #f5f5f5' }}>
                    <td style={{ padding: '8px 0' }}>{d.user?.name || d.guestName || 'Guest'}</td>
                    <td style={{ padding: '8px 0', textAlign: 'right', fontWeight: 700, color: 'var(--saffron)' }}>₹{d.amount?.toLocaleString('en-IN')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {/* Expense Breakdown */}
        <div style={{ background: '#fff', borderRadius: 12, padding: 24, boxShadow: '0 2px 16px rgba(0,0,0,0.08)' }}>
          <h3 style={{ fontWeight: 700, marginBottom: 16 }}>This Month's Expenses</h3>
          {stats.expenseByCategory?.length === 0 ? <p style={{ color: '#888' }}>No expenses recorded</p> : (
            <div>
              {stats.expenseByCategory?.map((e, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #f5f5f5', fontSize: '0.9rem' }}>
                  <span>{categoryLabel(e._id)}</span>
                  <span style={{ fontWeight: 700, color: '#8B4513' }}>₹{e.total?.toLocaleString('en-IN')}</span>
                </div>
              ))}
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0 0', fontWeight: 700, borderTop: '2px solid #e0e0e0', marginTop: 8 }}>
                <span>Total</span>
                <span style={{ color: '#c62828' }}>₹{stats.monthlyExpenses?.toLocaleString('en-IN')}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
